import {api} from "@/lib/api/auth/api";
import {IPushTokenRequest} from "@/lib/types/push/IPushTokenRequest";

/**
 * Device push-token registration against user-service (AUTH_API), Phase 1
 * PushTokenController — AC-649. REGISTER on opt-in, DEACTIVATE on logout. Both
 * are Bearer-authed via baseQueryWithRefresh (the shared auth `api`); the
 * backend checks the token belongs to the caller, so DEACTIVATE must run while
 * the accessToken is still valid (see LogOutForm).
 */
export const pushTokensApi = api.injectEndpoints({
    endpoints: build => ({
        registerPushToken: build.mutation<void, IPushTokenRequest>({
            query: (body) => ({
                url: '/api/v1/push-tokens',
                method: 'post',
                body,
            })
        }),
        // Backend deletes by body (not path): DELETE /api/v1/push-tokens { token }.
        deactivatePushToken: build.mutation<void, string>({
            query: (token) => ({
                url: '/api/v1/push-tokens',
                method: 'delete',
                body: {token},
            })
        }),
    })
})

export const {
    useRegisterPushTokenMutation,
    useDeactivatePushTokenMutation,
} = pushTokensApi;
